const inspection = {
  inspection: "仓储巡检",
  draft: "草稿",
  pending: "进行中",
  resolved: "已完成",
  rejected: "已取消",
  plState: "请选择巡检单状态",
  state: "状态",
  number: "巡检单号",
  createdAt: "创建时间",
  updatedAt: "操作时间",
  planAt: "计划时间",
  finishedAt: "完成时间",
  remark: "备注",
  detail: "详情",
  add: "添加",
  saveOk: "保存成功",
  saveErr: "保存失败",
  del: "删除",
  delOk: "删除成功",
  delErr: "删除失败",
  cancel: "取消",
  cancelTip: "确定取消这个巡检单吗？",
  cancelOk: "取消成功",
  cancelErr: "取消失败",
  notE: "不存在",
  exist: "存在",
  partE: "部分存在",
  notS: "不符合",
  suitable: "符合",
  partS: "部分符合",
  notInspect: "未检",
  config: "巡检配置",
  needInspection: "是否需要巡检",
  cycleDays: "巡检周期(天)",
  cycleDaysPlaceholder: "不填则为不定期/按需",
  content: "巡检内容说明",
  yes: "是",
  no: "否",
  day: "天",
  plsSelectIns: "请选择是否需要巡检",
  finish: "完成",
  finishTip: "你确定完成该巡检单吗？",
  finishOk: "该巡检单已完成",
  finishErr: "完成失败",
  inspector: "巡检员",
  locationCode: "库位编码",
  existenceState: "存在状态",
  complianceState: "符合度",
  action: "处理措施",
  inspectedAt: "巡检时间",
  addOrder: "添加巡检单",
  plProduct: "请选择要巡检的物料",
  plPlanAt: "请选择要巡检时间",
  addProduct: "添加物料",
  redPro: "标红物料无巡检配置",
  inspectProgress: "巡检进度",
  inspectItem: "巡检明细",
  attechment: "巡检附件",
  submitInspect: "提交巡检",
  submitSucc: "巡检提交成功",
  submitFail: "巡检提交失败",
  inspect: "巡检",
  specialHandlingAggregate: "存储环境状态",
  specialHandlingState: "存储环境还原",
  specialHandlingRemark: "备注",
  notSx: "未按要求",
  suitablex: "按要求",
  partSx: "部分按要求",
  notInspectx: "无需处理",
  unFinish: "有巡检项未巡检，不可完成",
  orderCanceled: "该巡检单已取消，巡检保存失败",
  orderFinished: "该巡检单已完成，巡检保存失败",
  configExsist: "该要求类型已存在，无需添加",
};

export default inspection;
